import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-pitch" data-id="element-85" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-4 sm:px-5" data-id="element-86" data-mp="9u37w1zr0c5x">
        <Reveal className="flex items-start gap-3 rounded-2xl border-2 border-field bg-cream p-3 text-left" data-id="element-87" data-mp="9wpe9yawklmk">
          <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border-2 border-gold bg-field" data-id="element-88" data-mp="jssid9pbeuc5">
            <ShieldCheckIcon size={24} className="text-white" data-id="element-89" data-mp="nt2mshxglcow" />
          </span>
          <div data-id="element-90" data-mp="skcbngb6obzq">
            <p className="font-sub text-xs font-extrabold uppercase tracking-wide text-pitch/80" data-id="element-91" data-mp="slvrx6wuan1i">
              Tu inversión está protegida
            </p>
            <h2 id="garantia" className="font-display text-xl uppercase leading-tight sm:text-3xl" data-id="element-92" data-mp="xlrwb79g8ghl">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-pitch/80 sm:text-sm" data-id="element-93" data-mp="17fqz88hck4al">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
              consideras que el sistema no es adecuado para ti, puedes
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}